import { Fragment, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { StatusBar } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

import MainApp from './MainApp';
import { theme } from './theme';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './app/store';
import AppUpdate from './AppUpdate';
import { useLiveUpdate } from './services/liveUpdate';
import ErrorBoundary from './components/common/ErrorBoundary';

export default function App() {
  useEffect(() => {
    const init = async () => {
      if (!Capacitor.isNativePlatform()) return;

      // Android WebView clamps pinch zoom to the viewport's maximum-scale,
      // so lift the cap there; iOS keeps it to suppress input auto-zoom
      // (zoomEnabled already allows pinch on iOS despite the cap).
      if (Capacitor.getPlatform() === 'android') {
        const viewport = document.querySelector('meta[name="viewport"]');

        if (viewport) {
          viewport.setAttribute(
            'content',
            'width=device-width, initial-scale=1, viewport-fit=cover'
          );
        }
      }

      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: '#2F527A' });
    };

    init();
  }, []);

  useLiveUpdate();

  const platform = Capacitor.getPlatform();

  const isIOSWeb =
    platform === 'web' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);

  const Boundary =
    platform !== 'web' || isIOSWeb
      ? Fragment
      : ErrorBoundary;

  return (
    <ThemeProvider theme={theme}>
      <Boundary>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AppUpdate>
              <MainApp />
            </AppUpdate>
          </PersistGate>
        </Provider>
      </Boundary>
    </ThemeProvider>
  );
}
